import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DocumentManagementServiceHandler } from './document-management.service.handler';

@Injectable()
export class DocumentManagementService extends DocumentManagementServiceHandler {
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
